import { notEmpty } from "@product/scmp-sdk";
import { useToggle } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { formatInTimeZone, toISOString } from "~/lib/utils";
import type { plusArticleDateContent$key } from "~/queries/__generated__/plusArticleDateContent.graphql";

import { PublishedDateContainer, StyledDiv, UpdatedDateContainer } from "./styles";

export type Props = {
  reference: plusArticleDateContent$key;
};

export const PlusArticleDate: FunctionComponent<Props> = ({
  reference: reference_,
  ...attribs
}) => {
  const content = useFragment(
    graphql`
      fragment plusArticleDateContent on Content {
        createdDate
        publishedDate
        updatedDate
      }
    `,
    reference_,
  );

  const [isToggle, setToggle] = useToggle(false);

  if (!content) return null;
  const dateFormat = "h:mmaaa, d MMM yyyy";
  const { createdDate, updatedDate } = content;
  const publishedDate = notEmpty(content.publishedDate) ? content.publishedDate : createdDate;
  const lastUpdatedDate = updatedDate ? formatInTimeZone(updatedDate, dateFormat) : publishedDate;

  const isoPublishedDate = publishedDate ? toISOString(publishedDate) : undefined;
  const isoUpdatedDate = updatedDate ? toISOString(updatedDate) : isoPublishedDate;

  return (
    <StyledDiv onClick={setToggle} {...attribs}>
      <UpdatedDateContainer $isToggle={isToggle}>
        <time dateTime={isoUpdatedDate}>Last Updated: {lastUpdatedDate}</time>
      </UpdatedDateContainer>

      {isToggle && updatedDate && (
        <PublishedDateContainer>
          <time dateTime={isoPublishedDate}>
            Published: {publishedDate && formatInTimeZone(publishedDate, dateFormat)}
          </time>
        </PublishedDateContainer>
      )}
    </StyledDiv>
  );
};

PlusArticleDate.displayName = "PlusArticleDate";
